import * as React from 'react';

import RelayClassic16 from './RelayClassic16';

export const relayClassic16 = () => <RelayClassic16 />;

export default {
    title: 'Icon/Fill/RelayClassic16',
    component: RelayClassic16,
    parameters: {
        notes: "`import RelayClassic16 from 'box-ui-elements/es/icon/fill/RelayClassic16';`",
    },
};
